import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import DiscussionsPane from './DiscussionsPane';
import MessagesPane from './MessagesPane';
import MembersPane from './MembersPane';
import GroupsPane from './GroupsPane';
import ForumsPane from './ForumsPane';
import AntiSpamPane from './AntiSpamPane';
import OrphanFilesPane from './OrphanFilesPane';
import DocumentsPane from './DocumentsPane';
export default class ModerationPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    const params = new URLSearchParams(window.location.search);
    const requestedTab = params.get('tab');
    this.initialDiscussionId = this.positiveId(params.get('discussion_id'));
    this.initialPostId = this.positiveId(params.get('post_id'));
    this.initialAuthor = params.get('author') || '';
    const validTabs = ['discussions', 'messages', 'members', 'groups', 'forums', 'documents', 'files', 'antispam'];
    const savedTab = sessionStorage.getItem('val-moderation-tab');
    this.activeTab = validTabs.includes(requestedTab) ? requestedTab : validTabs.includes(savedTab) ? savedTab : this.initialDiscussionId ? 'messages' : 'discussions';
  }
  setActiveTab(tab) {
    this.activeTab = tab;
    sessionStorage.setItem('val-moderation-tab', tab);
  }
  positiveId(value) {
    return value && /^\d+$/.test(value) && Number(value) > 0 ? value : '';
  }
  view() {
    const canFiles = !!app.forum.attribute('canManageValOrphanFiles');
    const canAntiSpam = !!app.forum.attribute('canManageValAntiSpam');
    return m('.ValModeration', [m('.container', [m('h1.ValModeration-title', 'Modération'), m('nav.ValModerationTabs', [m('button.ValModerationTab', {
      type: 'button',
      className: this.activeTab === 'discussions' ? 'is-active' : '',
      onclick: () => {
        this.setActiveTab('discussions');
      }
    }, 'Discussions'), m('button.ValModerationTab', {
      type: 'button',
      className: this.activeTab === 'messages' ? 'is-active' : '',
      onclick: () => {
        this.setActiveTab('messages');
      }
    }, 'Messages'), m('button.ValModerationTab', {
      type: 'button',
      className: this.activeTab === 'members' ? 'is-active' : '',
      onclick: () => {
        this.setActiveTab('members');
      }
    }, 'Membres'), m('button.ValModerationTab', {
      type: 'button',
      className: this.activeTab === 'groups' ? 'is-active' : '',
      onclick: () => {
        this.setActiveTab('groups');
      }
    }, 'Groupes'), m('button.ValModerationTab', {
      type: 'button',
      className: this.activeTab === 'forums' ? 'is-active' : '',
      onclick: () => {
        this.setActiveTab('forums');
      }
    }, 'Forums'), m('button.ValModerationTab', {
      type: 'button',
      className: this.activeTab === 'documents' ? 'is-active' : '',
      onclick: () => {
        this.setActiveTab('documents');
      }
    }, 'Documents'), canFiles ? m('button.ValModerationTab', {
      type: 'button',
      className: this.activeTab === 'files' ? 'is-active' : '',
      onclick: () => {
        this.setActiveTab('files');
      }
    }, 'Fichiers') : null, canAntiSpam ? m('button.ValModerationTab', {
      type: 'button',
      className: this.activeTab === 'antispam' ? 'is-active' : '',
      onclick: () => {
        this.setActiveTab('antispam');
      }
    }, 'Anti-spam') : null]), this.activeTab === 'messages' ? m(MessagesPane, {
      initialDiscussionId: this.initialDiscussionId,
      initialPostId: this.initialPostId,
      initialAuthor: this.initialAuthor
    }) : this.activeTab === 'members' ? m(MembersPane) : this.activeTab === 'groups' ? m(GroupsPane) : this.activeTab === 'forums' ? m(ForumsPane) : this.activeTab === 'documents' ? m(DocumentsPane) : this.activeTab === 'files' && canFiles ? m(OrphanFilesPane) : this.activeTab === 'antispam' && canAntiSpam ? m(AntiSpamPane) : m(DiscussionsPane, {
      initialAuthor: this.initialAuthor
    })])]);
  }
}